<template>
  <div
    class="app-header">
    <div class="logo" @click.stop="$router.push({ path: back })"></div>
    <transition v-bind:css="false" @enter="simpleTransition.enter" @leave="simpleTransition.leave" :mode="simpleTransition.mode" appear>
      <language-selector></language-selector>
    </transition>
  </div>
</template>
<script>
import simpleTransition from '@/transitions/simple'
import LanguageSelector from '@/components/ui/LanguageSelector'
export default {
  name: 'app-header',
  data () {
    return {
      simpleTransition
    }
  },
  components: {
    LanguageSelector
  },
  props: {
    back: {
      type: String,
      default: '/products'
    }
  }
}
</script>
<style lang='scss' scoped>
  .app-header {
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    padding-top: 50px;
    padding-left: 50px;
    padding-right: 50px;
    height: 12%;
    z-index: 900;
    .logo {
      margin: auto;
      background: url('../../assets/logo.png') center center no-repeat;
      background-size: contain;
      width: 450px;
      height: 160px;
    }
  }
</style>
